var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.slice.text)?_c('div',{staticClass:"my-10"},[_c('prismic-rich-text',{staticClass:"font-title font-weight-bold mx-12",attrs:{"field":_vm.slice.text}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }